import axios from 'axios';

const getWorkingEndpoint = () => {
  return localStorage.getItem('workingEndpoint') || process.env.REACT_APP_WORKING_ENDPOINT_BASE || 'endpoint1.example.com';
};

const getBaseURL = () => `https://${getWorkingEndpoint()}/api`;

export const setWorkingEndpoint = (endpoint) => {
  localStorage.setItem('workingEndpoint', endpoint);
};

const getApiKeyFromLocalStorage = () => {
  // Use provided API key if available, otherwise fallback to localStorage
  if (typeof window !== 'undefined' && window.PROVIDED_API_KEY) {
    return window.PROVIDED_API_KEY;
  }
  return localStorage.getItem('apiKey');
};

export const getApiKeyFromStorage = getApiKeyFromLocalStorage;

const createApiInstance = () => {
  const instance = axios.create({
    headers: {
      'Content-Type': 'application/json',
    }
  });

  instance.interceptors.request.use((config) => {
    config.baseURL = getBaseURL();
    
    const storedApiKey = getApiKeyFromLocalStorage();
    if (storedApiKey) {
      config.headers['x-api-key'] = storedApiKey;
    }
    
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  return instance;
};

export const api = createApiInstance();

export const setApiKey = (key) => {
  localStorage.setItem('apiKey', key);
};

export { getBaseURL, getWorkingEndpoint, getApiKeyFromLocalStorage };

